import img1 from '/static/img/experience/services/weddingPhotography/img1.png'
import img2 from '/static/img/experience/services/weddingPhotography/img2.png'
import img3 from '/static/img/experience/services/weddingPhotography/img3.png'
const weddingPhotographyInfo = {
    title: 'wedding photography',
    list: [
        {
            id: 1,
            img:img1,
            desc:'Providing top-tier wedding photography services in China'
        },
        {
            id: 2,
            img: img2,
            desc:'Photographers provide one-on-one service with a niche style.'
        }
        ,
        {
            id: 3,
            img:img3,
            desc:'Capturing the sweet moments of your journey through narrative storytelling.'
        }
    ]
}
export default {
    weddingPhotographyInfo
}